import React, {useEffect, useRef, useState} from "react";
import './services.scss'
import {getPropsFromState} from "../../redux/mapStateToProps";
import {connect} from "react-redux";
import {Link, useLocation, useParams} from "react-router-dom";
import {getUrlWithLocal} from "../../utils/getUrlWithLocal";
import {generateFileMediaUrl} from "../../utils/generateMediaUrl";
import CallModel from "../../components/modal/callModel/CallModel";

function Services(props) {
    const {staticTexts,selectedLanguage,services} = props
    const [callModelOpen, setCallModelOpen] = useState(false)
    const [servicesImage, setServicesImage] = useState(services[0]?.mediaArray[0]?.path);
    const [fade, setFade] = useState(true);
    const location = useLocation();

    const toggleCallBtn = () => {
        setCallModelOpen(!callModelOpen)
    }


    useEffect(()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    },[])

    useEffect(()=>{
        if(location?.state?.isHome){
            window.scrollTo({
                top: 700,
                behavior: "smooth"
            });
        }
    },[location?.state?.isHome])

    useEffect(() => {
        setFade(false);

        const timeout = setTimeout(() => {
            setFade(true);
        }, 300);

        return () => clearTimeout(timeout);
    }, [servicesImage]);

    return <div className={'services_page_wrapper'}>
        <div className={'services_header_block'}>
            <div className={'services_header_titles'}>
                <Link to={getUrlWithLocal('/home')}>{staticTexts?.services_general_link_text || 'Главная'}  /</Link>
                <span>{staticTexts?.services_link_text || 'Сервисы'}</span>
            </div>
        </div>
        <div className={'services_page_context'}>
            <div className={'services_top_block'}>
                <div className={'services_top_info'}>
                    <div className={'services_top_info_content'}>
                        {
                            services?.length ? services?.slice(0,4)?.map((item,index) => {
                                return <div className={'services_top_info_item'}
                                            onMouseEnter={() => setServicesImage(item?.mediaArray[0]?.path)}
                                            onMouseLeave={() => setServicesImage(services[0]?.mediaArray[0]?.path)}>
                                    <div className={'services_top_item_number'}>
                                        {index + 1}
                                    </div>
                                    <span className={'services_top_item_line'}/>
                                    <div className={'services_top_item_content'}>
                                        <div className={'services_top_item_content_title'}>
                                            {item?.title}
                                        </div>
                                        <div className={'services_top_item_content_description'}>
                                            {item.subTitle}
                                        </div>
                                    </div>
                                </div>
                            }) : ''
                        }
                    </div>
                    <div className={'services_modal_open'} onClick={() => setCallModelOpen(true)}>
                        {staticTexts?.services_call_btn_text || 'Запланировать звонок'}
                    </div>
                </div>
                <div className={'services_top_image'}>
                    <img src={generateFileMediaUrl(servicesImage)} alt="" style={{
                        // opacity: fade ? 1 : 0.5,
                        transition: 'all 0.3s ease-in-out',
                    }}/>
                </div>
            </div>
            {
                services?.length > 3 ? <div className={'services_bottom_block'}>
                    <div className={'services_bottom_image'}>
                        <img src={generateFileMediaUrl(services[4]?.mediaArray[0]?.path)} alt=""/>
                    </div>
                    <div className={'services_bottom_info'}>
                        <div className={'services_bottom_title'}>
                            {services[4]?.title}
                        </div>
                        <div className={'works_details_description'} dangerouslySetInnerHTML={{__html: services[4]?.description}}/>
                        <div className={'services_modal_open'} onClick={() => setCallModelOpen(true)}>
                            {staticTexts?.services_call_btn_text || 'Запланировать звонок'}
                        </div>
                    </div>
                </div> : ''
            }
        </div>
        {
            callModelOpen && <CallModel callModelOpen={callModelOpen}
                                        staticTexts={staticTexts}
                                        toggleCallBtn={toggleCallBtn}/>
        }
    </div>
}
const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'selectedLanguage',
    'services'
]);

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(Services);